import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=12f5b31c"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f5b31c')) {
      api.createRecord('12f5b31c', component.options)
    } else {
      api.reload('12f5b31c', component.options)
    }
    module.hot.accept("./Comment.vue?vue&type=template&id=12f5b31c", function () {
      api.rerender('12f5b31c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Comment.vue"
export default component.exports